import { render, staticRenderFns } from "./ListTemplate.vue?vue&type=template&id=17944504&scoped=true"
import script from "./ListTemplate.vue?vue&type=script&lang=ts"
export * from "./ListTemplate.vue?vue&type=script&lang=ts"
import style0 from "./ListTemplate.vue?vue&type=style&index=0&id=17944504&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17944504",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17944504')) {
      api.createRecord('17944504', component.options)
    } else {
      api.reload('17944504', component.options)
    }
    module.hot.accept("./ListTemplate.vue?vue&type=template&id=17944504&scoped=true", function () {
      api.rerender('17944504', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/templates/ListTemplate.vue"
export default component.exports